<template>
  <v-textarea
    ref="textarea"
    :value="value"
    @input="$emit('input', $event)"
    hide-details="auto"
    auto-grow
    rounded
    outlined
    class="text-area"
    :placeholder="placeholder"
    :label="label"
    :type="type"
    :rows="rows"
    :rules="rules"
  ></v-textarea>
</template>

<script>
export default {
  props: {
    placeholder: String,
    label: String,
    value: String,
    rows: Number,
    type: {
      type: String,
      default: "text",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value() {
      // Only step in for externally-driven changes (e.g. data arriving
      // from a fetch after mount). While the user is actively typing,
      // v-textarea's own onInput handler already recalculates the
      // height synchronously - re-triggering it here too can race with
      // that and fight over the DOM node's inline height.
      if (this.$refs.textarea?.isFocused) return;
      this.resize();
    },
  },
  mounted() {
    this.resize();
  },
  methods: {
    resize() {
      setTimeout(() => {
        this.$refs.textarea?.calculateInputHeight?.();
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.text-area {
  width: 100%;

  &::v-deep {
    &:not(.v-input--has-state) {
      fieldset {
        border-color: var(--v-border-base);
      }

      .v-input__slot:hover fieldset {
        border-color: rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>
